
import { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    furigana: '',
    phone: '',
    email: '',
    prefecture: '',
    city: '',
    service: '',
    roomSize: '',
    urgency: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // バリデーション
    if (!formData.name || !formData.phone || !formData.service) {
      alert('お名前、電話番号、ご希望のサービスは必須項目です。');
      return;
    }

    if (formData.message.length > 500) {
      alert('お問い合わせ内容は500文字以内で入力してください。');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4fbvofha0rqmnp6tig0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          furigana: '',
          phone: '',
          email: '',
          prefecture: '',
          city: '',
          service: '',
          roomSize: '',
          urgency: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-white to-pink-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">お問い合わせ</h2>
          <p className="text-lg text-gray-600 mb-6">
            お気軽にご相談ください。無料でお見積りいたします
          </p>
          <div className="bg-pink-50 border-2 border-pink-200 rounded-xl p-6 inline-block">
            <p className="text-pink-800 font-bold text-lg mb-2">
              <i className="ri-shield-check-line mr-2 w-5 h-5 inline-flex items-center justify-center"></i>
              無理な営業は一切いたしません
            </p>
            <p className="text-pink-700 text-sm">
              お客様のご要望をお聞きし、最適なプランをご提案いたします
            </p>
          </div>
        </div>

        <form 
          id="contact-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl shadow-xl p-8"
        >
          <div className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  お名前 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  placeholder="山田 太郎"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  フリガナ
                </label>
                <input
                  type="text"
                  name="furigana"
                  value={formData.furigana}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  placeholder="ヤマダ タロウ"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  電話番号 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  placeholder="090-1234-5678"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  メールアドレス
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  placeholder="example@email.com"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  都道府県
                </label>
                <select
                  name="prefecture"
                  value={formData.prefecture}
                  onChange={handleChange}
                  className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm cursor-pointer"
                >
                  <option value="">選択してください</option>
                  <option value="東京都">東京都</option>
                  <option value="神奈川県">神奈川県</option>
                  <option value="千葉県">千葉県</option>
                  <option value="埼玉県">埼玉県</option>
                  <option value="その他">その他</option>
                </select>
              </div>

              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  市区町村
                </label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  placeholder="渋谷区"
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-700 font-bold mb-2">
                ご希望のサービス <span className="text-red-500">*</span>
              </label>
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm cursor-pointer"
              >
                <option value="">選択してください</option>
                <option value="遺品整理">遺品整理</option>
                <option value="生前整理">生前整理</option>
                <option value="不用品回収">不用品回収</option>
                <option value="特殊清掃">特殊清掃</option>
                <option value="ゴミ屋敷片付け">ゴミ屋敷片付け</option>
                <option value="ご供養サービス">ご供養サービス</option>
                <option value="その他・相談">その他・相談</option>
              </select>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  お部屋の広さ
                </label>
                <select
                  name="roomSize"
                  value={formData.roomSize}
                  onChange={handleChange}
                  className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm cursor-pointer"
                >
                  <option value="">選択してください</option>
                  <option value="1K">1K</option>
                  <option value="1DK">1DK</option>
                  <option value="1LDK">1LDK</option>
                  <option value="2DK">2DK</option>
                  <option value="2LDK">2LDK</option>
                  <option value="3DK">3DK</option>
                  <option value="3LDK">3LDK</option>
                  <option value="4LDK以上">4LDK以上</option>
                  <option value="一戸建て">一戸建て</option>
                </select>
              </div>

              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  ご希望の対応時期
                </label>
                <select
                  name="urgency"
                  value={formData.urgency}
                  onChange={handleChange}
                  className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm cursor-pointer"
                >
                  <option value="">選択してください</option>
                  <option value="即日対応希望">即日対応希望</option>
                  <option value="1週間以内">1週間以内</option>
                  <option value="1ヶ月以内">1ヶ月以内</option>
                  <option value="時期未定・相談したい">時期未定・相談したい</option>
                </select>
              </div>
            </div>

            <div>
              <label className="block text-gray-700 font-bold mb-2">
                お問い合わせ内容
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                maxLength={500}
                rows={6}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm resize-none"
                placeholder="ご質問やご要望などをお聞かせください（500文字以内）"
              ></textarea>
              <div className="text-right text-sm text-gray-500 mt-1">
                {formData.message.length} / 500文字
              </div>
            </div>

            {submitStatus === 'success' && (
              <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4 text-green-800">
                <i className="ri-checkbox-circle-fill mr-2 w-5 h-5 inline-flex items-center justify-center"></i>
                お問い合わせを受け付けました。担当者より折り返しご連絡いたします。
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4 text-red-800">
                <i className="ri-error-warning-fill mr-2 w-5 h-5 inline-flex items-center justify-center"></i>
                送信に失敗しました。お手数ですがお電話にてお問い合わせください。
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg transition-colors shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {isSubmitting ? (
                <>
                  <i className="ri-loader-4-line animate-spin mr-2 w-5 h-5 inline-flex items-center justify-center"></i>
                  送信中...
                </>
              ) : (
                <>
                  <i className="ri-send-plane-fill mr-2 w-5 h-5 inline-flex items-center justify-center"></i>
                  無料見積りを依頼する
                </>
              )}
            </button>

            <p className="text-sm text-gray-600 text-center">
              お問い合わせいただいた内容は、プライバシーポリシーに基づき厳重に管理いたします。<br />
              無理な営業は一切いたしませんので、安心してご相談ください。
            </p>
          </div>
        </form>
      </div>
    </section>
  );
}
